module.exports = __webpack_public_path__ + "img/icon3-1.ad900286.png";